// extracted by mini-css-extract-plugin
module.exports = {"off-grid-R":"R_off-grid-R___Ppgk"};